import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { GruposPagoService } from '../../services/grupos-pago/grupos-pago.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

export interface DialogData 
{
    idGrupo: any
    codigo: string
    recarga: boolean
}

@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/grupos-pago/codigo-firma.component.html',
    styleUrls: ['../../pages/grupos-pago/grupos-pago.component.css']
})
export class DialogCodigoFirma
{  
    constructor( public dialogRef: MatDialogRef<DialogCodigoFirma>, private gruposPagoService: GruposPagoService,
                 @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog, ) { this.data.recarga = false }

    onGuardarClick(): void 
    {
        let vm = this
        let idUsuario = localStorage.getItem("idUsuario")
        Swal.fire({
            allowOutsideClick:false,
            icon:'info',
            text:'Cargando...'
          });
        Swal.showLoading();
        this.gruposPagoService.firmaAgrupacion(this.data.idGrupo,idUsuario, this.data.codigo).then
        (
            () => 
            {
                vm.data.recarga = true       
                vm.dialogRef.close()
                Swal.close();
                vm.openAlertDialog('La agrupación se ha firmado exitosamente.', 'btn-success')
            }
        )
        .catch
        (
            (error: any) =>
            {      
                vm.dialogRef.close()                
                console.log(error)
                Swal.close();
                vm.openAlertDialog('La agrupación no se ha logrado firmar.', 'btn-danger')
            }
        )
    }
    
    onCancelarClick(): void { this.dialogRef.close() }  

    openAlertDialog(mensaje: string, clase: string)  
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}